import React, { ReactElement, useContext, createRef, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Modal, Form, notification, Space, Button, Input, Image, Select } from 'antd'
import type { FormInstance } from 'antd/es/form'
import { SmileOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { popShowContext } from '@/pages/organStructure/organList'
import SelectUserOfIdName from '@/components/selectUserOfIdName'
import { IOrganPerson } from '@/store/models/organStructure.model'
import { IAppState } from '@/store/reducers'
import { IBu } from '@/store/models/auth.model'
import { getBUList } from '@/services/progress.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { RoleCont } from '@/store/constant/auth.constant'

function EditOrganStructurePop (): ReactElement {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const { isModalOpen, closePop, nodeData, title, mode } = useContext(popShowContext)
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const [ formData, setFormData ] = useState<any>(null)
    const [buLs, setBuLs] = useState<IBu[]>([])
    const formRef = createRef<FormInstance>()
    const { Option } = Select
    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
    }
    const onChangePerson = (obj: any) => {
        if (obj) {
            const result = {
                ...formData,
                ...obj,
                avatar: obj.avatar || '',
                email: obj.email || '',
                nickName: obj.nickName
            }
            setFormData(result)
            formRef.current?.setFieldsValue(result)
        } else {
            onReset()
        }
    }

    const roleArr = [
        {
            label: 'ITMT ChairMan',  
            value: RoleCont.ITMTCHAIRMAIN
        },  
        {
            label: 'ITMT Leader',
            value: RoleCont.ITMTLEADER
        },
        {
            label: 'ITMT SubLeader',
            value: RoleCont.ITMTSUBLEADER
        },
        {
            label: t('itmtUser'),
            value: RoleCont.ITMTMEMBER
        },
        {
            label: 'TSP',
            value: RoleCont.TSP
        },
        {
            label: 'PRG',
            value: RoleCont.PRG
        },
        {
            label: 'SecretaryGeneral',
            value: RoleCont.SecretaryGeneral
        },
        {
            label: 'CommitteeMembers',
            value: RoleCont.CommitteeMembers
        },
        {
            label: 'Co-ordinator',
            value: RoleCont.CoOrdinator
        },
        {
            label: 'PLTMT Leader',
            value: RoleCont.PLTMTLeader
        },
        {
            label: 'PLTMT SubLeader',
            value: RoleCont.PL_TMT_SUB_LEADER
        },
        {   
            label: 'PLTMT Member',       
            value: RoleCont.PL_TMT_MEMBER
        }
    ]
    const onFinish = async (values: IOrganPerson) => {
        let avatar = values.avatar
        if (avatar) {
            avatar = avatar.split('?path=').pop() || ''
            avatar = avatar.split('&token').shift() || ''
            avatar = decodeURIComponent(avatar)
        }
        closePop({
            ...values,
            avatar
        })
        onReset()
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any}) => {
        if (errorFields.length) {
            const args = {
                message: t('FinishFailed'),
                description: '',
                icon: <SmileOutlined style={{ color: '#e1931e' }} />,
                duration: 3,
            }
            notification.open(args)
        }
    }
    const onReset = () => {
        formRef.current?.resetFields()
        setFormData({
            workGroupId: formData?.workGroupId,
            parentId: formData?.parentId,
            avatar: '',
            bu: '',
            email: '',
            login: '',
            nickName: '',
            orgRole: undefined,
        })
    }

    const changeBu = (value: string) => {
        console.log('changeBu: ', value)
    }
    const changeRoleValue = (e:any)=>{
        const obj = {
            ...formData
        }
        obj.orgRole = e
        setFormData(obj)
    }
    const getBuLs = async () => {
        try {
            const res = await getBUList()
            setBuLs(res)
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    useEffect(() => {
        getBuLs()
    }, [])
    useEffect(() => {
        if (isModalOpen && mode === 'edit' && formData) {
            console.log('formData: ', JSON.parse(JSON.stringify(formData)))
            // 编辑后，树中的 wordGroup 变成了字符串( workGroupName 的值)，需要转换一下获取 workGroupId
            let findObj: any
            if (typeof formData.workGroup === 'string') {
                findObj = workgroupList.find(item => item.groupName === formData.workGroup)
            }
            formRef.current?.setFieldsValue({
                ...formData,
                workGroupId: findObj?.id || formData.workGroup?.id,
                parentId: formData.parent,
                orgRole: formData.orgRole,
                nickName: formData.nickName
            })
        }
    }, [isModalOpen])
    useEffect(() => {
        console.log('nodeData: ', nodeData)
        if (nodeData) {
            const obj = {
                ...nodeData
            }
            obj.id = mode === 'add' ? undefined : nodeData.id
            obj.workGroupId = nodeData.workGroup
            obj.parentId = nodeData.id
            setFormData(nodeData)
        }
    }, [nodeData])

    return (
        <Modal title={title} visible={isModalOpen} 
            onOk={() => {
                closePop()
                onReset()
            }}
            onCancel={() => {
                closePop()
                onReset()
            }}
            maskClosable={false}
            width={800}
            centered
            footer={[
                <Space size={20} key={1} style={{ display: 'flex', justifyContent: 'center' }}>
                    {mode !== 'view' && <Button type="primary" onClick={async () => {
                        try {
                            await formRef.current?.validateFields()
                            onFinish(formRef.current?.getFieldsValue())
                        } catch (e: any) {
                            console.log(e)
                        }
                    }}>
                        {t('submit')}
                    </Button>}
                    <Button htmlType="button" onClick={() => {
                        closePop()
                        onReset()
                    }}>
                        {t('close')}
                    </Button>
                </Space>
            ]}
        >
            <Form {...layout} ref={formRef}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Form.Item name="parentId" hidden>
                    <Input />
                </Form.Item>
                <Form.Item name="id" hidden>
                    <Input />
                </Form.Item>
                <Form.Item name="nickName" label={<span className='label'>{t('nickName')}</span>}
                    rules={[{ required: true, message: t('organPerson Required') }]}
                >
                    { mode === 'view'
                        ? (formData?.nickName || '')
                        : <SelectUserOfIdName onChange={onChangePerson} />
                    }
                </Form.Item>
                <Form.Item name="email" label={<span className='label'>{t('email')}</span>}>
                    { formData?.login
                        ? (formData?.email || '')
                        : (formData?.id ? '' : t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson'))
                    }
                </Form.Item>
                <Form.Item name="login" label={<span className='label'>{t('uidq')}</span>}>
                    { formData?.login
                        ? formData.login
                        : (formData?.id ? '' : t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson'))
                    }
                </Form.Item>
                <Form.Item name="bu" label={<span className='label'>{t('belongBU')}</span>}
                    rules={[{ required: true, message: t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('belongBU') }]}
                >
                    { mode === 'view'
                        ? (buLs.find(bu => bu.id === formData?.bu)?.bu ?? '')
                        : <Select placeholder={t('Please Select')  + (i18n.language !== 'zh' ? ' ' : '') + t('belongBU')} onChange={changeBu}>
                            {buLs.map((item) => (
                                <Option value={item.bu} key={item.id}>{item.bu}</Option>
                            ))}
                        </Select>
                    }
                </Form.Item>
                <Form.Item name="orgRole" label={<span className='label'>{t('orgRole')}</span>}
                    rules={[{ required: true, message: t('orgRole Required') }]}
                >
                    {/* ITMT ChairMan:1，ITMT Leader:2，ITMT SubLeader:3，ITMT成员:4,
                    TSP:5, PRG:6, 秘书长：7，委员：8, 统筹人：9, PLTMT Leader:10, */}
                    { mode === 'view'
                        ? (roleArr.find(item => item.value === formData?.orgRole)?.label || '')
                        : <Select placeholder={t('Please Select')  + (i18n.language !== 'zh' ? ' ' : '') + t('orgRole')} onChange={changeRoleValue}>
                            {roleArr.map((item, index) => (
                                <Option value={item.value} key={index}>{item.label}</Option>
                            ))}
                        </Select>
                    }
                </Form.Item>
                <Form.Item name="workGroupId" label={<span className='label'>{t('Work Group')}</span>}
                    rules={[{
                        required: (formData?.orgRole === 2 || formData?.orgRole === 3 || formData?.orgRole === 4),
                        message: t('workGroup Required')
                    }
                    ]}
                >
                    { mode === 'view'
                        ? (formData.workGroup?.workGroupName || '')
                        : <Select allowClear placeholder={t('Work Group Placeholder')}
                            disabled={formData?.orgRole == 1 || formData?.orgRole == 5 || formData?.orgRole === 6 || formData?.orgRole === 7 || formData?.orgRole === 8 || formData?.orgRole === 9}
                        >
                            {
                                workgroupList.map(item => {
                                    return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                                })
                            }
                        </Select>
                    }
                </Form.Item>
                
                <Form.Item name="avatar" label={<span className='label'>{t('avatar')}</span>}>
                    {formData && formData.avatar && <Image preview={false} src={formData.avatar} />}
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default EditOrganStructurePop
